var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext, useMemo } from "react";
import { AccordionContext } from "./Accordion.context";
var AccordionContent = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "className", "style"]);
    var contextValue = useContext(AccordionContext);
    if (!contextValue) {
        throw new Error("AccordionContent must be used within AccordionContext provider");
    }
    var id = contextValue.id, expanded = contextValue.expanded;
    var currentClass = useMemo(function () {
        return expanded ? "fr-collapse fr-collapse--expanded" : "fr-collapse";
    }, [expanded]);
    var combinedClassName = "".concat(currentClass, " ").concat(className || "");
    return (React.createElement("div", __assign({}, otherProps, { className: combinedClassName, id: id, style: expanded ? __assign(__assign({}, style), { maxHeight: "none" }) : style, ref: ref, role: "region", "aria-labelledby": "".concat(id, "-header") }), expanded ? children : undefined));
});
export default AccordionContent;
